const VITE_MODE = import.meta.env.MODE;

export class AuthenticationTokenService {
    private static readonly AUTH_TOKEN_COOKIE_NAME = "nucleus_chatbot_token";
    private static readonly MAX_AGE_SECONDS = 60*60; /*     */
    private static readonly COOKIE_DOMAIN = VITE_MODE === "development" ? "" : "domain=.otto.de;";
    private static readonly TOKEN_LOGIN_URL = VITE_MODE === "development" ? "/chat/auth.html" : "/chat/auth";
    private static readonly CHAT_URL = VITE_MODE === "development" ? "/chat/chat.html" : "/";

    /**
 *
 *
 */
    static setToken(token: string) {
        this.setCookie(this.AUTH_TOKEN_COOKIE_NAME, token, this.MAX_AGE_SECONDS);
        this.redirectToHome();
    }

    /**
 *
 */
    static validateToken() {
        if (!this.hasToken()) {
            this.redirectToLogin();
        }
    }

    /**
 *
 */
    static handleInvalidToken() {
        this.redirectToLogin();
    }

    /**
 *
 */
    public static hasToken(): boolean {
        return document.cookie.split("; ").some((cookie) => cookie.indexOf(this.AUTH_TOKEN_COOKIE_NAME) === 0);
    }

    private static setCookie(name: string, value: string, maxAgeSeconds: number): void {
        document.cookie = `${name}=${value}; path=/; ${this.COOKIE_DOMAIN} max-age=${maxAgeSeconds};`;
    }

    private static redirectToLogin() {
        window.location.href = this.TOKEN_LOGIN_URL;
    }

    private static redirectToHome() {
        window.location.href = this.CHAT_URL;
    }
}
